import { changeFieldsIdWithDisplayName } from '../services/ValidateService';

function extractTemplateFieldIds(template) {
  const ids = [];
  const re = /\{\{([^}]+)\}\}/g;
  let m;
  while ((m = re.exec(template)) !== null) {
    const fieldArea = m[1];
    const fieldId = fieldArea.includes('|') ? fieldArea.substring(0, fieldArea.indexOf('|')) : fieldArea;
    ids.push(fieldId.trim());
  }
  return ids;
}

function canApplyDefaultTemplate(template, productFields) {
  if (!template) return false;
  const ids = extractTemplateFieldIds(template);
  if (ids.length === 0) return true;
  return ids.every((id) => productFields.some((f) => f.id === id));
}


export function pickDefaultTemplate(defaultTemplate, productFields) {
  if (!defaultTemplate) return null;
  const list = Array.isArray(defaultTemplate) ? defaultTemplate : [defaultTemplate];
  for (const tpl of list) {
    if (typeof tpl === 'string' && tpl.length > 0 && canApplyDefaultTemplate(tpl, productFields)) {
      return tpl;
    }
  }
  return null;
}

export function buildFeedTemplateMappings(feed, productFields = []) {
  if (!feed) return [];

  if (!feed.fields || feed.fields.length === 0) {
    return [
      { feedFieldId: '', value: '', required: false, readonly: false, error: '', type: 'field' },
    ];
  }

  const required = feed.fields.filter((t) => t.required === true).map((t) => {
    const tpl = pickDefaultTemplate(t.defaultTemplate, productFields);
    if (tpl) {
      return {
        feedFieldId: t.name,
        value: changeFieldsIdWithDisplayName(tpl, productFields),
        required: true,
        readonly: Boolean(t.readonly),
        error: '',
        type: 'field',
        hidden: Boolean(t.hidden),
      };
    }

    const defaults = t.default ?? [];
    let defaultValue = '';
    for (const v of defaults) {
      const existField = productFields.find((field) => field.id === v);
      if (existField) {
        defaultValue = changeFieldsIdWithDisplayName(`{{${existField.id}}}`, productFields);
        break;
      }
    }
    return {
      feedFieldId: t.name,
      value: defaultValue,
      required: true,
      readonly: Boolean(t.readonly && defaultValue),
      error: '',
      type: 'field',
    };
  });

  required.push({
    feedFieldId: undefined,
    value: '',
    required: false,
    readonly: false,
    error: '',
    type: 'field',
  });

  return required;
}
